export const BASE_URL = `https://s3.us-east-2.amazonaws.com/seint.com/color-match/`
export const LOADING = {
	src: `${BASE_URL}loading.jpg`,
	alt: 'Preparing your results',
}
export const LEVELS = {
	'Level I': {
		level: 1,
		images: [
			{
				sublevel: 'A',
				value: 1,
				alt: `Level I A`,
				src: `${BASE_URL}Level_I_A.jpg`,
			},
			{
				sublevel: 'B',
				value: 2,
				alt: `Level I B`,
				src: `${BASE_URL}Level_I_B.jpg`,
			},
			{
				sublevel: 'C',
				value: 3,
				alt: `Level I C`,
				src: `${BASE_URL}Level_I_C.jpg`,
			},
			{
				sublevel: 'D',
				value: 4,
				alt: `Level I D`,
				src: `${BASE_URL}Level_I_D.jpg`,
			},
		],
	},
	'Level II': {
		level: 2,
		images: [
			{
				sublevel: 'A',
				value: 1,
				alt: `Level II A`,
				src: `${BASE_URL}Level_II_A.jpg`,
			},
			{ sublevel: 'B', value: 2, alt: `Level II B`, src: `${BASE_URL}Level_II_B.jpg` },
			{
				sublevel: 'C',
				value: 3,
				alt: `Level II C`,
				src: `${BASE_URL}Level_II_C.jpg`,
			},
			{
				sublevel: 'D',
				value: 4,
				alt: `Level II D`,
				src: `${BASE_URL}Level_II_D.jpg`,
			},
		],
	},
	'Level III': {
		level: 3,
		images: [
			{
				sublevel: 'A',
				value: 1,
				alt: `Level III A`,
				src: `${BASE_URL}Level_III_A.jpg`,
			},
			{
				sublevel: 'B',
				value: 2,
				alt: `Level III B`,
				src: `${BASE_URL}Level_III_B.jpg`,
			},
			{
				sublevel: 'C',
				value: 3,
				alt: `Level III C`,
				src: `${BASE_URL}Level_III_C.jpg`,
			},
			{
				sublevel: 'D',
				value: 4,
				alt: `Level III D`,
				src: `${BASE_URL}Level_III_D.jpg`,
			},
		],
	},
	'Level IV': {
		level: 4,
		images: [
			{
				sublevel: 'A',
				value: 1,
				alt: `Level IV A`,
				src: `${BASE_URL}Level_IV_A.jpg`,
			},
			{
				sublevel: 'B',
				value: 2,
				alt: `Level IV B`,
				src: `${BASE_URL}Level_IV_B.jpg`,
			},
			{
				sublevel: 'C',
				value: 3,
				alt: `Level IV C`,
				src: `${BASE_URL}Level_IV_C.jpg`,
			},
			{
				sublevel: 'D',
				value: 4,
				alt: `Level IV D`,
				src: `${BASE_URL}Level_IV_D.jpg`,
			},
		],
	},
	'Level V': {
		level: 5,
		images: [
			{
				sublevel: 'A',
				value: 1,
				alt: `Level V A`,
				src: `${BASE_URL}Level_V_A.jpg`,
			},
			{
				sublevel: 'B',
				value: 2,
				alt: `Level V B`,
				src: `${BASE_URL}Level_V_B.jpg`,
			},
			{
				sublevel: 'C',
				value: 3,
				alt: `Level V C`,
				src: `${BASE_URL}Level_V_C.jpg`,
			},
			{
				sublevel: 'D',
				value: 4,
				alt: `Level V D`,
				src: `${BASE_URL}Level_V_D.jpg`,
			},
		],
	},
	'Level VI': {
		level: 6,
		images: [
			{
				sublevel: 'A',
				value: 1,
				alt: `Level VI A`,
				src: `${BASE_URL}Level_VI_A.jpg`,
			},
			{
				sublevel: 'B',
				value: 2,
				alt: `Level VI B`,
				src: `${BASE_URL}Level_VI_B.jpg`,
			},
			{
				sublevel: 'C',
				value: 3,
				alt: `Level VI C`,
				src: `${BASE_URL}Level_VI_C.jpg`,
			},
			{
				sublevel: 'D',
				value: 4,
				alt: `Level VI D`,
				src: `${BASE_URL}Level_VI_D.jpg`,
			},
		],
	},
	'Level VII': {
		level: 7,
		images: [
			{
				sublevel: 'A',
				value: 1,
				alt: `Level VII A`,
				src: `${BASE_URL}Level_VII_A.jpg`,
			},
			{
				sublevel: 'B',
				value: 2,
				alt: `Level VII B`,
				src: `${BASE_URL}Level_VII_B.jpg`,
			},
			{
				sublevel: 'C',
				value: 3,
				alt: `Level VII C`,
				src: `${BASE_URL}Level_VII_C.jpg`,
			},
			{
				sublevel: 'D',
				value: 4,
				alt: `Level VII D`,
				src: `${BASE_URL}Level_VII_D.jpg`,
			},
		],
	},
	'Level VIII': {
		level: 8,
		images: [
			{ sublevel: 'A', value: 1, alt: `Level VIII A`, src: `${BASE_URL}Level_VIII_A.jpg` },
			{ sublevel: 'B', value: 2, alt: `Level VIII B`, src: `${BASE_URL}Level_VIII_B.jpg` },
			{
				sublevel: 'C',
				value: 3,
				alt: `Level VIII C`,
				src: `${BASE_URL}Level_VIII_C.jpg`,
			},
			{
				sublevel: 'D',
				value: 4,
				alt: `Level VIII D`,
				src: `${BASE_URL}Level_VIII_D.jpg`,
			},
		],
	},
	'Level IX': {
		level: 9,
		images: [
			{
				sublevel: 'A',
				value: 1,
				alt: `Level IX A`,
				src: `${BASE_URL}Level_IX_A.jpg`,
			},
			{
				sublevel: 'B',
				value: 2,
				alt: `Level IX B`,
				src: `${BASE_URL}Level_IX_B.jpg`,
			},
			{
				sublevel: 'C',
				value: 3,
				alt: `Level IX C`,
				src: `${BASE_URL}Level_IX_C.jpg`,
			},
			{
				sublevel: 'D',
				value: 4,
				alt: `Level IX D`,
				src: `${BASE_URL}Level_IX_D.jpg`,
			},
		],
	},
	'Level X': {
		level: 10,
		images: [
			{
				sublevel: 'A',
				value: 1,
				alt: `Level X A`,
				src: `${BASE_URL}Level_X_A.jpg`,
			},
			{
				sublevel: 'B',
				value: 2,
				alt: `Level X B`,
				src: `${BASE_URL}Level_X_B.jpg`,
			},
			{
				sublevel: 'C',
				value: 3,
				alt: `Level X C`,
				src: `${BASE_URL}Level_X_C.jpg`,
			},
			{
				sublevel: 'D',
				value: 4,
				alt: `Level X D`,
				src: `${BASE_URL}Level_X_D.jpg`,
			},
		],
	},
	'Level XI': {
		level: 11,
		images: [
			{
				sublevel: 'A',
				value: 1,
				alt: `Level XI A`,
				src: `${BASE_URL}Level_XI_A.jpg`,
			},
			{
				sublevel: 'B',
				value: 2,
				alt: `Level XI B`,
				src: `${BASE_URL}Level_XI_B.jpg`,
			},
			{
				sublevel: 'C',
				value: 3,
				alt: `Level XI C`,
				src: `${BASE_URL}Level_XI_C.jpg`,
			},
			{
				sublevel: 'D',
				value: 4,
				alt: `Level XI D`,
				src: `${BASE_URL}Level_XI_D.jpg`,
			},
		],
	},
	'Level XII': {
		level: 12,
		images: [
			{
				sublevel: 'A',
				value: 1,
				alt: `Level XII A`,
				src: `${BASE_URL}Level_XII_A.jpg`,
			},
			{
				sublevel: 'B',
				value: 2,
				alt: `Level XII B`,
				src: `${BASE_URL}Level_XII_B.jpg`,
			},
			{
				sublevel: 'C',
				value: 3,
				alt: `Level XII C`,
				src: `${BASE_URL}Level_XII_C.jpg`,
			},
			{
				sublevel: 'D',
				value: 4,
				alt: `Level XII D`,
				src: `${BASE_URL}Level_XII_D.jpg`,
			},
		],
	},
}
